export const getPattern = (multipleOf)=>{
    const decimals = getNumberOfDecimals(multipleOf);
    const regex = multipleOf === 1 || typeof multipleOf === 'undefined' || multipleOf === null ? `^-?\\d*?$` : `^-?\\d*(\\.\\d{0,${decimals}})?$`;
    return regex;
};
export const getNumberOfDecimals = (multipleOf)=>{
    return String(multipleOf).split('.')?.[1]?.length || 0;
};
export const getValidNumberInput = (input, multipleOf, previousValidValue, locale)=>{
    if (input.trim() === '') {
        return {
            validInput: '',
            validNumber: undefined
        }; // allow clear input
    }
    const inputNumber = inputToNumber(input);
    if (isNumberInputValid(inputNumber, multipleOf) && inputNumber < Number.MAX_SAFE_INTEGER) {
        return {
            validInput: localizeNumberInput(input, locale),
            validNumber: inputNumber
        };
    }
    return previousValidValue ? {
        validInput: previousValidValue,
        validNumber: inputToNumber(previousValidValue)
    } : {
        validInput: '',
        validNumber: undefined
    };
};
const inputToNumber = (input)=>Number(normalizeDecimalSeparator(input));
export const localizeNumberInput = (input, locale)=>{
    const decimalSeparator = locale ? Intl.NumberFormat(locale).formatToParts(1.1).find((part)=>part.type === 'decimal')?.value : undefined;
    return decimalSeparator ? input.replace(/[.,]/, decimalSeparator) : input;
};
export const isNumberInputValid = (value, multipleOf)=>{
    const multipleOfRegex = getPattern(multipleOf);
    const validator = new RegExp(multipleOfRegex);
    return validator.test(`${value}`);
};
export const normalizeDecimalSeparator = (value = '')=>value.replace(',', '.');
export const isNumberInputPossible = (value = '', multipleOf)=>{
    if (multipleOf === 1 && value.indexOf('.') !== -1) {
        return false;
    } else if (value === '.' || value === '-') {
        return true;
    }
    return isNumberInputValid(Number(value), multipleOf);
};

//# sourceMappingURL=numeric-input-utils.js.map